// extracted by mini-css-extract-plugin
export default {"RTEWrapper":"EditableBotMessage_RTEWrapper__v39uy"};